import { TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_4 } from '../../../../../config/tables'
import { TablaDetalleEspacioPorCerealLinea4Service } from '../../../../../models/movimiento/distribucionEspacioPorCereal/Tabla_detalle_espacio_por_cereal_linea_4'
import { COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_4, COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_4_TO_PRINT } from './constantesDetalleEspacioPorCerealLinea4'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_4
    })
    const promiseTablaDetalleEspacioPorCerealLinea4 = TablaDetalleEspacioPorCerealLinea4Service.getDataTablaDetalleEspacioPorCerealLinea4()
    const promiseTablaDetalleEspacioPorCerealLinea4Total = TablaDetalleEspacioPorCerealLinea4Service.getDataTablaDetalleEspacioPorCerealLinea4Total()
    Promise.all([promiseTablaDetalleEspacioPorCerealLinea4, promiseTablaDetalleEspacioPorCerealLinea4Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Espacio Por Cereal Sector 4',
        dataCombinada,
        COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_4_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_4,
          data: dataCombinada,
          title: `Espacio Por Cereal Sector 4`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, print: false, pagination: false }
        },
        id: TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_4
      })
    }
  }
}
